import { Command, Id } from '@nextforce/api'
import { StoreUserNonAvailability } from 'non_availability/queries/types'

interface Props {
  nonAvailabilities: StoreUserNonAvailability[] | undefined
  requestId?: Id
  onCommandButtonPress: (
    command: Command,
    nonAvailability: StoreUserNonAvailability
  ) => Promise<void>
}

export function NonAvailabilityDetailsView() {
  return null
}
